import 'regenerator-runtime/runtime';
import Alpine from 'alpinejs';
import focus from '@alpinejs/focus';
import intersect from '@alpinejs/intersect';
import { accordionBehavior } from '../patterns/03-organisms/accordion/accordion.behavior';
import { backToTopBehavior } from '../patterns/01-atoms/back-to-top/back-to-top.behavior';
import { breadcrumbsBehavior } from '../patterns/02-molecules/breadcrumbs/breadcrumbs.behavior';
import { carouselBehavior } from "../patterns/02-molecules/carousel/carousel.behavior";
import { inPageNavBehavior } from '../patterns/03-organisms/in-page-navigation/in-page-navigation.behavior';
import { interactiveImageBehavior } from '../patterns/02-molecules/interactive-image/interactive-image.behavior';
import { megamenuBehavior, megamenuItemBehavior } from '../patterns/03-organisms/megamenu/megamenu.behavior';
import { menuItem } from '../patterns/01-atoms/menu-item/menu-item.behavior';
import { searchBarBehavior } from '../patterns/02-molecules/search-bar/search-bar.behavior';
import { sectionBehavior } from '../patterns/04-templates/section/section.behavior';
import { videoBehavior } from '../patterns/01-atoms/video/video.behavior';
Alpine.plugin(intersect);
Alpine.plugin(focus);
Drupal.behaviors.alpinejs = {
  isStarted: false,
  attach: function attach() {
    this.registerEvents();
    this.start();
  },
  /**
   * Register custom Alpine data functions.
   */
  alpineData: function alpineData() {
    accordionBehavior();
    backToTopBehavior();
    breadcrumbsBehavior();
    carouselBehavior();
    inPageNavBehavior();
    interactiveImageBehavior();
    menuItem();
    megamenuBehavior();
    megamenuItemBehavior();
    searchBarBehavior();
    sectionBehavior();
    videoBehavior();
  },
  start: function start() {
    this.alpineData();
    if (this.isStarted === false) {
      Alpine.start();
      window.Alpine = Alpine;
    }
  },
  registerEvents: function registerEvents() {
    var _this = this;
    document.addEventListener('alpine:initialized', function () {
      if (_this.isStarted === false) {
        _this.isStarted = true;
      }
    });
  }
};